import src from "IMAGE";
export default { src, width: 2171, height: 785, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARklEQVR42i3MsQmAQBREwQMDS1HQTNHALqxAzMRAjASrssNzPlwwGy0v5Zw/DlZGOibakMzNzsvCwExPE4eNi4eziFpN9QNs/k7GBY98fQAAAABJRU5ErkJggg=="};
